const CYRILLIC_RE = /[а-яА-ЯіІїЇєЄґҐёЁ]/;
function hasCyrillic(value) {
    return CYRILLIC_RE.test(value);
}
export function stripPhone(value) {
    return value.replace(/[^\d+]/g, '');
}
export function normalizePhoneDigits(digits) {
    if (digits.startsWith('380') && digits.length === 12)
        return digits;
    if (digits.startsWith('80') && digits.length === 11)
        return '3' + digits;
    if (digits.startsWith('0') && digits.length === 10)
        return '38' + digits;
    if (digits.startsWith('373') && digits.length === 11)
        return digits;
    return digits;
}
export function formatPhoneMask(value) {
    const raw = value.replace(/[^\d]/g, '');
    if (raw.length === 0)
        return '';
    if (raw.startsWith('380') ||
        (raw.startsWith('80') && raw.length >= 3) ||
        (raw.startsWith('0') && raw.length >= 2)) {
        const d = raw.startsWith('380') ? raw : raw.startsWith('80') ? '3' + raw : '38' + raw;
        let result = '+380';
        if (d.length > 3)
            result += ' (' + d.slice(3, 5);
        if (d.length > 5)
            result += ') ' + d.slice(5, 8);
        if (d.length > 8)
            result += '-' + d.slice(8, 10);
        if (d.length > 10)
            result += '-' + d.slice(10, 12);
        return result;
    }
    if (raw.startsWith('373')) {
        let result = '+373';
        if (raw.length > 3)
            result += ' ' + raw.slice(3, 6);
        if (raw.length > 6)
            result += ' ' + raw.slice(6, 9);
        if (raw.length > 9)
            result += ' ' + raw.slice(9, 11);
        return result;
    }
    let result = '+' + raw[0];
    for (let i = 1; i < raw.length && i < 15; i++) {
        if (i === 3 || i === 6 || i === 8)
            result += ' ';
        result += raw[i];
    }
    return result;
}
function validatePhoneNumber(value) {
    if (!value)
        return null;
    if (hasCyrillic(value)) {
        return 'validation:noCyrillic';
    }
    const digits = value.replace(/[^\d]/g, '');
    if (digits.length < 10) {
        return 'validation:minDigits10';
    }
    if (digits.length > 15) {
        return 'validation:phoneTooLong';
    }
    const normalized = normalizePhoneDigits(digits);
    const isUA = normalized.startsWith('380') && normalized.length === 12;
    const isMD = normalized.startsWith('373') && normalized.length === 11;
    if (!isUA && !isMD) {
        return 'validation:phoneFormat';
    }
    return null;
}
export const validatePhone = validatePhoneNumber;
const TG_USERNAME_RE = /^[a-zA-Z][a-zA-Z0-9_]{4,31}$/;
export function normalizeTelegram(value) {
    return value.replace(/^@/, '');
}
export function validateTelegram(username) {
    if (!username)
        return null;
    const clean = normalizeTelegram(username);
    if (clean.length < 5) {
        return 'validation:minLength5';
    }
    if (clean.length > 32) {
        return 'validation:maxLength32';
    }
    if (!TG_USERNAME_RE.test(clean)) {
        return 'validation:tgUsernameFormat';
    }
    return null;
}
export const validateWhatsApp = validatePhoneNumber;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function validateEmail(email) {
    if (!email)
        return null;
    if (!EMAIL_RE.test(email)) {
        return 'validation:emailFormat';
    }
    return null;
}
export function validateContacts(contacts) {
    const errors = {};
    const hasAnyContact = contacts.phone || contacts.telegram || contacts.whatsapp || contacts.email;
    if (!hasAnyContact) {
        errors.preferred = 'validation:specifyPhone';
        return errors;
    }
    const phoneErr = validatePhone(contacts.phone || '');
    if (phoneErr)
        errors.phone = phoneErr;
    const tgErr = validateTelegram(contacts.telegram || '');
    if (tgErr)
        errors.telegram = tgErr;
    const wsErr = validateWhatsApp(contacts.whatsapp || '');
    if (wsErr)
        errors.whatsapp = wsErr;
    const emailErr = validateEmail(contacts.email || '');
    if (emailErr)
        errors.email = emailErr;
    const validPreferred = ['telegram', 'phone', 'whatsapp', 'email'];
    if (!validPreferred.includes(contacts.preferred)) {
        errors.preferred = 'validation:unknownContactMethod';
    }
    if (contacts.preferred === 'telegram' && !contacts.telegram) {
        errors.preferred = 'validation:specifyTelegram';
    }
    if (contacts.preferred === 'phone' && !contacts.phone) {
        errors.preferred = 'validation:specifyPhone';
    }
    if (contacts.preferred === 'whatsapp' && !contacts.whatsapp) {
        errors.preferred = 'validation:specifyWhatsApp';
    }
    if (contacts.preferred === 'email' && !contacts.email) {
        errors.preferred = 'validation:specifyEmail';
    }
    return errors;
}
//# sourceMappingURL=validation.js.map